/** Old link to one CSW report: carried over, filters and all, to the one warehouse list at CSW. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { cswReportSearch } from "@/features/warehouse/reports/csw-api";

export const Route = createFileRoute("/_app/reports/csw/$key")({
  validateSearch: cswReportSearch,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/reports/warehouse/$slug",
      params: { slug: params.key },
      search: { ...search, stage: "condition" },
      replace: true,
    });
  },
});
